module.exports = __webpack_public_path__ + "img/acv1.e305bfe0.png";